export type CreateTagErrorCode = 'PERMISSION_DENIED' | 'MISSING_ARGUMENT' | 'NAME_ALREADY_EXISTS' | 'UNKNOWN';

export class CreateTagError extends Error {
    code: CreateTagErrorCode;

    constructor(code: CreateTagErrorCode, message: string) {
        super(message);
        this.code = code;
    }
}
